import axios from "axios";
import store from "@/core/store/index";
import { getCookieValue } from "@/core/utils/cookie";

/**
 * Attach Bearer Token to Axios requests
 */
axios.interceptors.request.use(
  function (config) {
    const token = store.state.oidcStore.access_token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

/**
 * In local/dev environment cookie authentication is prioritized and used
 * Because of that, we need to provide matching XSRF token
 */
const tokenCookieName = "XSRF-TOKEN";
const tokenHeaderName = "RequestVerificationToken";

axios.interceptors.request.use(
  function (config) {
    const cookie = getCookieValue(tokenCookieName);
    if (cookie != null) {
      config.headers[tokenHeaderName] = `${cookie}`;
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);
